import React from 'react';

import { components } from 'react-select';
import { StyledGrid } from 'styles/common';

import theme from 'constants/theme';

import { Typography14 } from 'uiToolkit/Typography';

import { AVAILABLE_TAG_ICONS } from './TagIcon';

export const DriverOption = (props) => (
  <components.Option {...props}>
    <StyledTag {...props} />
  </components.Option>
);

export const DriverSingleValue = (props) => (
  <components.SingleValue {...props}>
    <StyledTag {...props} />
  </components.SingleValue>
);

export const StyledTag = (props) => {
  const tag = props.data;
  const IconTag = AVAILABLE_TAG_ICONS[tag?.value];
  return (
    <StyledGrid container alignItems="center">
      {IconTag}
      <Typography14 color={theme.palette.text.blackv1} leftGutter={1}>
        {tag?.label}
      </Typography14>
    </StyledGrid>
  );
};
